import { useMutation } from '@tanstack/react-query';
import type { AuthError, Session } from '@kmgestao/supabase-client';

import { supabase } from '../../lib/supabase.js';
import type { SignInInput } from './schemas.js';

interface SignInResult {
  session: Session;
}

/**
 * Autentica via email + senha + captchaToken. `SessionProvider` captura a
 * nova sessão automaticamente via `onAuthStateChange`. O consumidor
 * tipicamente navega para `state.from ?? '/dashboard'` em `onSuccess`.
 */
export function useSignIn() {
  return useMutation<SignInResult, AuthError, SignInInput>({
    mutationFn: async ({ email, password, captchaToken }) => {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
        options: { captchaToken },
      });
      if (error) throw error;
      if (!data.session) {
        throw new Error('Sessão não retornada pelo Supabase.') as AuthError;
      }
      return { session: data.session };
    },
  });
}
